import { useVendorConfig } from './VendorContext';
import { ComponentKey } from './vendorTypes';

export const useVendorComponent = (component: ComponentKey) => {
    const { components } = useVendorConfig();

    return components?.[component] ?? (() => null);
};
